export default "__VITE_ASSET__SAejAxSc__"